import {BASE_URL} from "../constants";

export const getCallInfo = async (token) => {
    const response = await fetch(`${BASE_URL}/api/call`, {
        method: "get",
        headers: {"Authorization": `Bearer ${token}`}
    });
    return await response.json()
}
export const verifyOtp = async (transactionId, otp, token) => {
    const response = await fetch(`${BASE_URL}/api/call/verify-otp`, {
        method: "POST",
        headers: {
            "Authorization": `Bearer ${token}`, 'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        cache: "no-cache",

        body: JSON.stringify({transactionId, otp})
    });
    return await response.json()
}
export const approvalContract = async (token) => {
    const response = await fetch(`${BASE_URL}/api/call/approval`, {
        method: "POST",
        headers: {
            "Authorization": `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        cache: "no-cache",
        body: JSON.stringify({approval: 1})
    });
    return await response.json()
}
export const rejectContract = async (token) => {
    const response = await fetch(`${BASE_URL}/api/call/approval`, {
        method: "POST",
        headers: {
            "Authorization": `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        cache: "no-cache",
        body: JSON.stringify({approval: 0})
    });
    return await response.json()
}
export const reassignOtp = async (transactionId, token) => {
    try {
        const response = await fetch(`${BASE_URL}/api/call/reassign-otp`, {
            method: "POST",
            headers: {"Authorization": `Bearer ${token}`},
            cache: "no-cache",
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            body: JSON.stringify({transactionId})
        })
        return await response.json()
    } catch (e) {
        console.log(e)
    }

}
export const checkCallExists = async (token) => {
    try {
        const response = await fetch(`${BASE_URL}/api/call/call-exists`, {
            method: "get",
            headers: {"Authorization": `Bearer ${token}`}
        });
        return await response.json()
    } catch (e) {
        console.error(e)
    }

}
export const setCustomerAction = async (token, customerAction) => {
    try {
        const response = await fetch(`${BASE_URL}/api/call/customer-action`, {
            method: "POST",
            headers: {
                "Authorization": `Bearer ${token}`,
                cache: "no-cache",
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },

            body: JSON.stringify({customerAction})
        })
        return await response.json()
    } catch (e) {
        console.log(e)
    }

}